var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.61875 13.9274C0.99375 14.0837 1.42187 13.9962 1.70937 13.7118L7 8.41806V13.0024C7 13.4056 7.24375 13.7712 7.61875 13.9274C7.99375 14.0837 8.42188 13.9962 8.70938 13.7118L14 8.41806V13.0024C14 13.5556 14.4469 14.0024 15 14.0024C15.5531 14.0024 16 13.5556 16 13.0024V1.00243C16 0.449305 15.5531 0.00243049 15 0.00243049C14.4469 0.00243049 14 0.449305 14 1.00243V5.58681L8.70625 0.293056C8.41875 0.0055556 7.99063 -0.0788195 7.61563 0.0774305C7.24063 0.233681 7 0.599306 7 1.00243V5.58681L1.70625 0.296181C1.41875 0.00868055 0.990625 -0.0756945 0.615625 0.0805555C0.240625 0.236806 0 0.599306 0 1.00243V13.0024C0 13.4056 0.24375 13.7712 0.61875 13.9274Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardFast);
export default __webpack_public_path__ + "static/media/forward-fast.a7a4a1a822e91e07b303af08036e78be.svg";
export { ForwardRef as ReactComponent };